<template>
    <div v-if="!loading">
        <div class="header-actions">
            <CorpId />
            <CompassButton
                :label="$t.__('developerPage.MyApps.add_application')"
                type="primary"
                class="ml-3"
                @click="createApp"
            />
        </div>

        <p class="mt-0">
            {{
                $l10n.__(
                    "Cette section est réservée aux développeurs, vous retrouvez ici l'ensemble des applications que vous avez créées et utilisant l'API Sellsy",
                )
            }}
        </p>
        <p>
            {{
                $l10n.__(
                    "Si vous êtes développeur, vous pourrez trouver les informations nécessaires au développement de votre application sur le site de l'API",
                )
            }}
        </p>

        <consumer v-for="consumer in apps" :key="consumer.token_id" :consumer="consumer" />
    </div>
    <preloader v-else :background="false" :display="true" />
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import Consumer from 'vcomponents/developerPage/Consumer.vue';
import CorpId from 'vcomponents/developerPage/CorpId.vue';

export default {
    components: {
        Preloader,
        Consumer,
        CorpId,
    },
    data() {
        return {
            loading: true,
            apps: [],
        };
    },
    created() {
        this.getMyApps()
            .then((apps) => (this.apps = apps))
            .finally(() => (this.loading = false));
    },
    methods: {
        getMyApps() {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/developer/my-apps`, {}, (response) => {
                    resolve(response);
                });
            });
        },
        createApp() {
            Api.genAppForm();
        },
    },
};
</script>
